<template>
  <section id="hero-section" class="section">
    <section-content-wrapper>
      <div class="hero-section-wrapper">
        <article class="hero-column">
          <h1 class="hero-column-title">Skorzystaj z finansowania i przyspiesz rozwój swojej firmy</h1>
          <p class="hero-column-text">Oferta dla firm korzystających z Płatności Online Autopay</p>
          <ul class="hero-column-list">
            <li class="hero-column-list-item">
              <img class="hero-column-list-item-icon" src="@/assets/images/icons/money-icon-white.svg" alt="" aria-hidden="true">
              <h2 class="hero-column-list-item-heading heading-font">150 000 zł</h2>
              <p class="hero-column-list-item-text">Maksymalna kwota finansowania</p>
            </li>
            <li class="hero-column-list-item">
              <img class="hero-column-list-item-icon" src="@/assets/images/icons/clock-icon-white.svg" alt="" aria-hidden="true">
              <h2 class="hero-column-list-item-heading heading-font">24h</h2>
              <p class="hero-column-list-item-text">Czas na wypłatę środków</p>
            </li>
          </ul>
        </article>
        <img class="hero-image" src="@/assets/images/hero-image.png" alt="Logo Brutto" aria-hidden="true">
    </div>
    </section-content-wrapper>
  </section>
</template>

<script>

import SectionContentWrapper from '../common/SectionContentWrapper'

export default {
  name: 'HeroSection',
  components: {
    SectionContentWrapper
  }
}
</script>
